export default {
    chat: {
        dialog: {
            label: 'CHAT SESSION',
            newConversation: 'New conversation',
        },
        header: {
            title: 'NOCWARE AI AGENT',
            subtitle: 'Ask me anything about your Projects, Sites, or Devices!',
        },
        input: {
            placeholder: 'Type a message',
            stop: 'Stop response',
        },
        error: {
            connectionFailed:
                "Couldn't reach the server. Please check your connection and try again.",
            unauthorized: 'Your session has expired. Please log in again.',
            streamInterrupted: 'The response was interrupted. Please try again.',
            httpError:
                'Something went wrong on our end (Error {status}). Please try again in a moment.',
        },
    },
};
